(function Module() {
'use strict';

var _ = require('lodash');
var Entities = require('html-entities').AllHtmlEntities;

module.exports = {
	makePossessive: function makePossessive(str) {
		str = str || '';

		return str.charAt(str.length - 1) === 's' ? str + "'" : str + "'s";
	},

	pluralize: function pluralize(str) {
		return (str || '').replace(/y$/, 'ie') + 's';
	},

	genderizePronoun: function genderizePronoun(gender, malePronoun) {
		if (!gender) {
			return '___';
		}

		if (_.includes(['f', 'female', 'girl', 'woman'], gender.toLowerCase())) {
			var pronounGenderChanges = {
				he: 'she',
				him: 'her',
				his: 'her' //FIXME: is this car hers?
			};

			return pronounGenderChanges[malePronoun];
		}

		return malePronoun;
	},

	camelToTitle: function camelToTitle(str) {	//	convert camelCaseString to Title Case String
		return _.capitalize((str || '').replace(/([A-Z])/g, ' $1'));
	},

	alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''),

	cacheBustUrl: function cacheBustUrl(url) {
		url = url || '';

		if (_.contains(url, '?')) {
			return url + '&_=' + (+moment());
		}

		return url  + '?_=' + (+moment());
	},

	//	'HOrsE maRt' --> 'Horse Mart'
	toTitleCase: function toTitleCase(str) {
		return (str || '').replace(/\w\S+/g, function convertToTitleCase(txt) {
			return _.capitalize(txt.toLowerCase());
		});
	},

	// entities.encode('<>"\'&©®'); // &lt;&gt;&quot;&apos;&amp;©®
	// entities.encodeNonUTF('<>"\'&©®'); // &lt;&gt;&quot;&apos;&amp;&#169;&#174;
	// entities.encodeNonASCII('<>"\'&©®'); // <>"\'&©®
	// entities.decode('&lt;&gt;&quot;&apos;&amp;&copy;&reg;&#8710;'); // <>"'&&copy;&reg;∆
	entities: new Entities()
};
})();
